import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import {
  TextField,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Typography,
  MenuItem,
  Modal,
  FormLabel,
  Card,
  Pagination,
  CustomTableCell,
  Table,
  Alert,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//^------------------THUNKS----------------------------
import {
  getDataPasscodeStatusWise,
  getPreferredManagersList,
  changeRequestedPasscodeStatus,
  rejectPasscodeStatus,
} from "./PasscodeStatus.thunk";
import moment from "moment/moment";
//^------------------------------------------------------

//?---------------OPTIONS --------------------
const statusOptions = [
  { value: "requested", text: "Requested" },
  { value: "allocated", text: "Accepted" },
  { value: "rejected", text: "Rejected" },
];
//?--------------------------------------------------------------------

const PasscodeStatus = () => {
  const [passcodeStatus, setPasscodeStatus] = useState("requested");
  const [allPasscodeData, setAllPasscodeData] = useState([]);
  const [allManagerData, setAllManagerData] = useState([]);
  const [selectPreferredManager, setSelectPreferredManager] = useState("");
  const [contactnumber, setContactnumber] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [userid, setUserid] = useState("");
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectPreferredManager("");
    setUserid("");
    setUsername("");
  };

  const handleModalOpen = (e) => {
    setModalOpen(true);
    setUserid(e.userid);
    setUsername(e.username);
    setContactnumber(e.contactnumber);
  };

  //*---------------------------Shows the table according to the passcode status (if any)-----
  useEffect(() => {
    setLoading(true);
    getDataPasscodeStatusWise(passcodeStatus).then((res) => {
      if (res.status === 200) {
        setAllPasscodeData(res.data);
      } else {
        setAllPasscodeData([]);
      }
    });
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, [passcodeStatus, refresh]);

  //*------------------------------For getting the manager list ------------------------------------
  useEffect(() => {
    if (modalOpen === true) {
      const data = {
        managerType: "manager",
      };
      getPreferredManagersList(data).then((res) => {
        if (res.status === 200) {
          setSelectPreferredManager("");
          setAllManagerData(res.data);
        } else if (res.status === 204) {
          setAllManagerData([]);
          setSelectPreferredManager("");
          toast.error("No manager is there under this managertype !");
        } else {
          setAllManagerData([]);
          setSelectPreferredManager("");

          toast.error("Sorry, Something went wrong !");
        }
      });
    }
  }, [modalOpen]);
  // const handleManagerTypes = (e) => {
  //   if (!e.target.value) {
  //     setManagerType("");
  //     setSelectPreferredManager("");
  //   } else {
  //     setManagerType(e.target.value);
  //     setSelectPreferredManager("");
  //   }
  // };

  const onPasscodeStatusChange = (e) => {
    setPasscodeStatus(e.target.value);
  };

  const onPreferredManagerChange = (e) => {
    if (!e.target.value) {
      setSelectPreferredManager("");
    } else {
      setSelectPreferredManager(e.target.value);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  //~--------------------Change passcode status [Accept]-------------------------

  const acceptPasscodeRequest = () => {
    if (!selectPreferredManager) {
      toast.error("You have to select a manager before proceeding");
    } else if (!passcodeGenerated[0]?.passcode) {
      toast.error(
        "Unable to assign ! This manager currently doesn't have a passcode "
      );
    } else {
      setModalOpen(false);
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to allocate this user under selected manager?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#03C03C",
        confirmButtonText: "Accept",
      })
        .then((result) => {
          if (result.isConfirmed) {
            const data = {
              userid: userid,
              username: username,
              usertype: "fellow",
              managerid: selectPreferredManager,
              managername: managerName[0]?.managername,
              passcode: passcodeGenerated[0]?.passcode,
              contactnumber: contactnumber,
            };
            changeRequestedPasscodeStatus(data).then((res) => {
              if (res.status === 200) {
                setRefresh(true);
                //console.log("refresh------------->", refresh);
                toast.success("Successfully updated the request.");
                setUserid("");
                setUsername("");
              } else {
                toast.error("Sorry, could not update this request !");
                setUserid("");
                setUsername("");
              }
            });
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
  };
  //~------------------------------------------------------------------------

  //!----------------------------Change passcode status [Reject]----------------
  const rejectIncomingRequest = (item) => {
    setUserid(item.userid);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to reject this passcode request !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      confirmButtonText: "Reject",
    })
      .then((result) => {
        if (result.isConfirmed) {
          const data = {
            userid: item.userid,
            username: item.username,
            contactnumber: item.contactnumber,
          };
          console.log("data------------->", data);
          rejectPasscodeStatus(data).then((res) => {
            if (res.status === 200) {
              setRefresh(true);
              toast.success("Successfully updated the passcode status !");
              setUserid("");
              setUsername("");
            } else {
              // setRefresh(false);
              toast.error("Sorry, something went wrong !");
            }
          });
        }
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  //!-------------------------------------------------------------------------

  const passcodeGenerated = allManagerData.filter(
    (item) => item.managerid === selectPreferredManager
  );

  const managerName = allManagerData?.filter(
    (item) => item.managerid === selectPreferredManager
  );

  //?--------------------console logs----------------------------------------------------
  // //console.log("passcodeStatus------------------------>", passcodeStatus);
  //console.log("allPasscodeData------------------------->", allPasscodeData);
  //console.log("allManagerData------------------------->", allManagerData);
  //console.log("managerid--------------------->", selectPreferredManager);
  // //console.log(
  //   "passcodeGenerated--------------------->",
  //   passcodeGenerated[0]?.passcode
  // );
  //console.log(
  //   "allPasscodeData.length----------------->",
  //   allPasscodeData?.length
  // );
  //console.log("Userid--------------->", userid);
  //console.log("username--------------->", username);
  //console.log(
  //   "managername-------------------------->",
  //   managerName[0]?.managername
  // );
  //console.log("passcode---------------->", passcodeGenerated[0]?.passcode);
  //console.log("refresh------------->", refresh);

  //?------------------------------------------------------------------------------------------

  return (
    <div>
      <MuiHeader header="Passcode Requests Status" />

      <FormControl
        sx={{ marginTop: "20px", width: "15%", marginLeft: "40px" }}
        size="small"
      >
        <InputLabel id="demo-select-small">Passcode Status</InputLabel>
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          value={passcodeStatus}
          label="Passcode Status"
          onChange={onPasscodeStatusChange}
        >
          {statusOptions.map((option) => (
            <MenuItem value={option.value}>{option.text}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
        <div
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "#7a7373",
            marginTop: "20px",
            marginLeft: "60px",
          }}
        >
          <div>
            {allPasscodeData.length > 0 ? allPasscodeData.length : 0} Record(s)
            found
          </div>
        </div>
      </FormControl>

      {/* table  */}
      {!loading &&
      passcodeStatus === "requested" &&
      allPasscodeData?.length > 0 ? (
        <>
          <Paper
            style={{
              minWidth: "100%",
              marginTop: "38px",
              display: "flex",
              // flexWrap: "wrap",
            }}
          >
            <Table>
              <TableHead style={{ backgroundColor: "#C8C8C8" }}>
                <TableRow>
                  <TableCell style={{ width: "9%", paddingLeft: "30px" }}>
                    Sl no.
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "33px",
                      wordBreak: "break-all",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell style={{ width: "10%" }}>Phone No.</TableCell>
                  <TableCell
                    style={{
                      width: "10%",
                      paddingLeft: "80px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "20px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Preferred Manager
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "25px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Previous Passcode
                  </TableCell>
                  <TableCell style={{ width: "10%", paddingLeft: "40px" }}>
                    Location
                  </TableCell>
                  <TableCell style={{ width: "13%", paddingLeft: "86px" }}>
                    Requested Date
                  </TableCell>
                  <TableCell style={{ width: "24%", paddingLeft: "105px" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              {allPasscodeData
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((item, index) => (
                  <TableBody key={index}>
                    <TableRow>
                      <TableCell style={{ width: "9%", paddingLeft: "30px" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ width: "13%", paddingLeft: "33px" }}>
                        {item.username}
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        {item.contactnumber}
                      </TableCell>
                      <TableCell
                        style={{
                          width: "10%",
                          paddingLeft: "60px",
                          // wordBreak: "break-word",
                        }}
                      >
                        {item.emailid}
                      </TableCell>
                      {item.preferredManager ? (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "20px",
                          }}
                        >
                          {item.preferredManager}
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "50px",
                          }}
                        >
                          NA
                        </TableCell>
                      )}
                      {item?.previousPasscode ? (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "27px",
                          }}
                        >
                          {item?.previousPasscode}
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "50px",
                          }}
                        >
                          NA
                        </TableCell>
                      )}
                      <TableCell style={{ width: "10%", paddingLeft: "40px" }}>
                        {item.blockname}, {item.districtname}
                      </TableCell>
                      <TableCell style={{ width: "13%", paddingLeft: "87px" }}>
                        {moment(item.createdon).format("DD/MM/YY")}
                      </TableCell>

                      <TableCell
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "38px",
                        }}
                      >
                        <Button
                          size="small"
                          onClick={() => handleModalOpen(item)}
                          variant="contained"
                        >
                          Accept
                          <CheckRoundedIcon
                            sx={{
                              height: "20px",
                              width: "20px",
                              color: "white",
                            }}
                          />
                        </Button>
                        <Button
                          size="small"
                          onClick={() => rejectIncomingRequest(item)}
                          variant="contained"
                          style={{
                            backgroundColor: "red",
                            marginLeft: "10px",
                          }} // Adjust margin as needed
                        >
                          Reject
                          <ClearRoundedIcon
                            sx={{
                              height: "20px",
                              width: "20px",
                              color: "white",
                            }}
                          />
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))}
            </Table>
          </Paper>

          <div>
            <TablePagination
              rowsPerPageOptions={[5, 10, allPasscodeData.length]}
              component="div"
              count={allPasscodeData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </>
      ) : !loading &&
        passcodeStatus === "allocated" &&
        allPasscodeData?.length > 0 ? (
        <>
          <Paper
            style={{
              minWidth: "100%",
              marginTop: "38px",
              display: "flex",
              // flexWrap: "wrap",
            }}
          >
            <Table>
              <TableHead style={{ backgroundColor: "#C8C8C8" }}>
                <TableRow>
                  <TableCell style={{ width: "9%", paddingLeft: "30px" }}>
                    Sl no.
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "33px",
                      wordBreak: "break-all",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell style={{ width: "10%" }}>Phone No.</TableCell>
                  <TableCell
                    style={{
                      width: "10%",
                      paddingLeft: "100px",
                      wordBreak: "break-all",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "25px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Preferred Manager
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "25px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Passcode
                  </TableCell>
                  <TableCell style={{ width: "10%", paddingLeft: "30px" }}>
                    Location
                  </TableCell>
                  <TableCell style={{ width: "13%", paddingLeft: "80px" }}>
                    Requested Date
                  </TableCell>
                  <TableCell style={{ width: "10%", paddingLeft: "50px" }}>
                    Request Status
                  </TableCell>
                </TableRow>
              </TableHead>
              {allPasscodeData
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((item, index) => (
                  <TableBody key={index}>
                    <TableRow>
                      <TableCell style={{ width: "9%", paddingLeft: "30px" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ width: "13%", paddingLeft: "33px" }}>
                        {item.username}
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        {item.contactnumber}
                      </TableCell>
                      <TableCell style={{ width: "10%", paddingLeft: "70px" }}>
                        {item.emailid}
                      </TableCell>
                      {item.preferredManager ? (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "20px",
                          }}
                        >
                          {item.preferredManager}
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "50px",
                          }}
                        >
                          NA
                        </TableCell>
                      )}
                      {item?.previousPasscode ? (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "27px",
                          }}
                        >
                          {item?.previousPasscode}
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "50px",
                          }}
                        >
                          NA
                        </TableCell>
                      )}
                      <TableCell style={{ width: "10%", paddingLeft: "30px" }}>
                        {item.blockname}, {item.districtname}
                      </TableCell>
                      <TableCell style={{ width: "13%", paddingLeft: "80px" }}>
                        {moment(item.createdon).format("DD/MM/YY")}
                      </TableCell>

                      <TableCell style={{ width: "10%", paddingLeft: "50px" }}>
                        Accepted
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))}
            </Table>
          </Paper>
          <div>
            <TablePagination
              rowsPerPageOptions={[5, 10, allPasscodeData.length]}
              component="div"
              count={allPasscodeData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </>
      ) : !loading &&
        passcodeStatus === "rejected" &&
        allPasscodeData?.length > 0 ? (
        <>
          <Paper
            style={{
              minWidth: "100%",
              marginTop: "38px",
              display: "flex",
              // flexWrap: "wrap",
            }}
          >
            <Table>
              <TableHead style={{ backgroundColor: "#C8C8C8" }}>
                <TableRow>
                  <TableCell style={{ width: "9%", paddingLeft: "30px" }}>
                    Sl no.
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "33px",
                      wordBreak: "break-all",
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell style={{ width: "10%" }}>Phone No.</TableCell>
                  <TableCell
                    style={{
                      width: "10%",
                      paddingLeft: "100px",
                      wordBreak: "break-all",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "25px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Preferred Manager
                  </TableCell>
                  <TableCell
                    style={{
                      width: "13%",
                      paddingLeft: "25px",
                      // wordBreak: "break-all",
                    }}
                  >
                    Previous Passcode
                  </TableCell>
                  <TableCell style={{ width: "10%", paddingLeft: "30px" }}>
                    Location
                  </TableCell>
                  <TableCell style={{ width: "13%", paddingLeft: "80px" }}>
                    Requested Date
                  </TableCell>
                  <TableCell style={{ width: "10%", paddingLeft: "50px" }}>
                    Request Status
                  </TableCell>
                </TableRow>
              </TableHead>
              {allPasscodeData
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((item, index) => (
                  <TableBody key={index}>
                    <TableRow>
                      <TableCell style={{ width: "9%", paddingLeft: "30px" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ width: "13%", paddingLeft: "33px" }}>
                        {item?.username}
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        {item?.contactnumber}
                      </TableCell>
                      <TableCell style={{ width: "10%", paddingLeft: "70px" }}>
                        {item?.emailid}
                      </TableCell>
                      {item?.preferredManager ? (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "27px",
                          }}
                        >
                          {item?.preferredManager}
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "50px",
                          }}
                        >
                          NA
                        </TableCell>
                      )}
                      {item?.previousPasscode ? (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "27px",
                          }}
                        >
                          {item?.previousPasscode}
                        </TableCell>
                      ) : (
                        <TableCell
                          style={{
                            width: "13%",
                            wordBreak: "break-word",
                            paddingLeft: "50px",
                          }}
                        >
                          NA
                        </TableCell>
                      )}
                      <TableCell style={{ width: "10%", paddingLeft: "30px" }}>
                        {item?.blockname}, {item?.districtname}
                      </TableCell>
                      <TableCell style={{ width: "13%", paddingLeft: "80px" }}>
                        {moment(item?.createdon).format("DD/MM/YY")}
                      </TableCell>

                      <TableCell style={{ width: "10%", paddingLeft: "50px" }}>
                        Rejected
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))}
            </Table>
          </Paper>
          {allPasscodeData.length > 0 ? (
            <TablePagination
              rowsPerPageOptions={[5, 10, allPasscodeData.length]}
              component="div"
              count={allPasscodeData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          ) : null}
        </>
      ) : null}

      {/* modal */}
      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box sx={style}>
          <FormControl
            sx={{ m: 1 }}
            size="small"
            style={{ minWidth: 300, marginLeft: 65, marginTop: 20 }}
          >
            <InputLabel>Select Manager</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              label="Select Manager"
              value={selectPreferredManager}
              onChange={onPreferredManagerChange}
              style={{ padding: 8 }}
            >
              <MenuItem value="">None</MenuItem>
              {allManagerData.map((option, index) => (
                <MenuItem key={index + 1} value={option.managerid}>
                  {option.managername}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectPreferredManager ? (
            <FormControl
              sx={{ m: 1 }}
              size="small"
              style={{ minWidth: 300, marginLeft: 65, marginTop: 20 }}
            >
              {/* <InputLabel>Passcode</InputLabel> */}
              <TextField
                disabled
                id="outlined-disabled"
                label={
                  <div
                    style={{
                      wordBreak: "break-all",
                      color: "#343434",
                    }}
                  >
                    {passcodeGenerated[0]?.passcode
                      ? passcodeGenerated[0]?.passcode
                      : "This manager has no passcode !"}
                  </div>
                }
              />
            </FormControl>
          ) : null}
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 10,
            }}
          >
            <Button
              variant="contained"
              onClick={handleModalClose}
              style={{ marginTop: 10 }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={acceptPasscodeRequest}
              style={{ marginTop: 10 }}
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>
      {/* Toaster */}
      <MuiLoader open={loading} />
      <ToastContainer />
      {/* <MuiLoader open={loading} /> */}
    </div>
  );
};

export default PasscodeStatus;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 10,
  p: 4,
};
